import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
//import axios from 'axios';
import './IDDetails.css';
import { getEmployeeDetailsBasedonEmployeeUniqueeId, getRelationships, submitIdDetails } from '../../../../../../services/employeeCreationService';
import { getAuditLog } from '../../../../../../utils/calculateDaysInMonthUtils';
import { selectStyleDisable, selectStyles } from "../../../../../../assets/Styles/selectStyle";
import { capitalizeFirstLetter, getFileName, isAlphabet } from '../../../../../../utils/validations';
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";


const IDDetails = ({ onNext, onPrevious }) => {
    const effectRan = useRef(false);
    const [searchParams] = useSearchParams();
    const location = useLocation();
   // const employeeUniqueId = searchParams.get('employeeUniqueId') || location.state?.applicationId;

    const fromUrl = searchParams.get('employeeUniqueId');   // <-- from query string
      const fromState = location.state?.applicationId;        // <-- from navigation state
    
      // Use the URL value **only if it exists** – otherwise fall back to state
      const employeeUniqueId = fromUrl ?? fromState;
      const [completed, setCompleted] = useState(false);   // <-- NEW
      const isLocked = Boolean(fromUrl && completed);
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [idDetails, setIdDetails] = useState({
        id: null,
        aadhaarNumber: '',
        nameAsAadhar: '',
        panCardNumber: '',
        nameAsPerPanCard: '',
        uanNumber: '',
        uanMemberId: '',
        esiNumber: '',
        nomineeName: '',
        relationship: '',
        uploadAadhaar: null,
        uploadPan: null,
        uploadUan: null,
        uploadEsi: null,
        passportSizePhoto: null,
        fatherGivenName: '',
        fatherSurname: '',
        uploadFatherIdProof: null,
        creamyLayerFile:null,
        motherGivenName: '',
        motherSurname: '',
        uploadMotherIdProof: null,
        spouseGivenName: '',
        spouseSurname: '',
        uploadSpouseIdProof: null,
        uploadPhysicalHandicappedCertificate: null,
        isNomineeStayingWithYou: false,
        aadhaarVerified: null,
        aadhaarComment: null,
        panVerified: null,
        panComment: null,
        uanVerified: null,
        uanComment: null,
        esiVerified: null,
        esiComment: null,
        photoVerified: null,
        photoComment: null,
        emailSent: false,
        verifiedBy: null,
        updatedBy: '',
        createdDate: null,
        updatedDate: null,
    });
    const [hasUan, setHasUan] = useState('');
    const [hasEsi, setHasEsi] = useState('');
    const [nomineeStaying, setNomineeStaying] = useState('');
    const [relationshipOptions, setRelationshipOptions] = useState([]);
    const [errors, setErrors] = useState({});

  //  const [completed, setCompleted] = useState(false);   // <-- NEW
    const isFieldDisabled = completed;
    const [isFocused, setIsFocused] = useState({
        aadhaarNumber: false,
        nameAsAadhar: false,
        panNumber: false,
        panName: false,
        uanNumber: false,
        uanMemberId: false,
        esiNumber: false,
        nomineeName: false,
        relationship: false,
        fatherGivenName: false,
        fatherSurname: false,
        motherGivenName: false,
        motherSurname: false,
        spouseGivenName: false,
        spouseSurname: false,
    });
    const [submitError, setSubmitError] = useState('');
    const [fileErrors, setFileErrors] = useState({
        uploadAadhaar: '',
        uploadPan: '',
        uploadUan: '',
        uploadEsi: '',
        creamyLayerFile:"",
        passportSizePhoto: '',
        uploadFatherIdProof: '',
        uploadMotherIdProof: '',
        uploadSpouseIdProof: '',
        uploadPhysicalHandicappedCertificate: '',
    });
    const [personalInfo, setPersonalInfo] = useState({
        givenName: '',
        surname: '',
        jobPosition: '',
    });
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    // Load data from localStorage
    useEffect(() => {
        const savedData = localStorage.getItem('idDetails');
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            setIdDetails((prev) => ({
                ...prev,
                ...parsedData,
                uploadAadhaar: parsedData.uploadAadhaar ? { name: parsedData.uploadAadhaar.name } : null,
                uploadPan: parsedData.uploadPan ? { name: parsedData.uploadPan.name } : null,
                uploadUan: parsedData.uploadUan ? { name: parsedData.uploadUan.name } : null,
                uploadEsi: parsedData.uploadEsi ? { name: parsedData.uploadEsi.name } : null,
                passportSizePhoto: parsedData.passportSizePhoto ? { name: parsedData.passportSizePhoto.name } : null,
                uploadFatherIdProof: parsedData.uploadFatherIdProof ? { name: parsedData.uploadFatherIdProof.name } : null,
                uploadMotherIdProof: parsedData.uploadMotherIdProof ? { name: parsedData.uploadMotherIdProof.name } : null,
                uploadSpouseIdProof: parsedData.uploadSpouseIdProof ? { name: parsedData.uploadSpouseIdProof.name } : null,
                uploadPhysicalHandicappedCertificate: parsedData.uploadPhysicalHandicappedCertificate ? { name: parsedData.uploadPhysicalHandicappedCertificate.name } : null,
                creamyLayerFile:parsedData.creamyLayerFile?{name:parsedData.creamyLayerFile.name}:null,
            }));
        }
    }, []);

    // Save to localStorage on idDetails change
    useEffect(() => {
        localStorage.setItem('idDetails', JSON.stringify(idDetails));
    }, [idDetails]);

    // Fetch relationships
    useEffect(() => {
        const fetchRelationships = async () => {
            try {
                const data = await getRelationships();
                if (Array.isArray(data)) {
                    setRelationshipOptions(
                        data.map((rel) => ({
                            value: rel.id,
                            label: rel.relation,
                        }))
                    );
                    setSubmitError(""); // clear error
                } else {
                    console.error("Invalid response format: relationships should be an array");
                    setSubmitError("Failed to load relationships");
                }
            } catch (error) {
                setSubmitError("Failed to load relationships");
            }
        };

        if (!effectRan.current) {
            fetchRelationships();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    // Fetch application details
    useEffect(() => {
        const fetchApplicationDetails = async () => {
            if (!employeeUniqueId) return;
            try {
                const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);

                if (appData.employeeIDDetails) {
                    const details = appData.employeeIDDetails;

                    setIdDetails({
                        id: details.id || null,
                        aadhaarNumber: details.aadhaarNumber || '',
                        nameAsAadhar: details.nameAsPerAadhaar || '',
                        panCardNumber: details.panCardNumber || '',
                        nameAsPerPanCard: details.nameAsPerPanCard || '',
                        uanNumber: details.uanNumber || '',
                        uanMemberId: details.uanMemberId || '',
                        esiNumber: details.esiNumber || '',
                        nomineeName: details.nomineeName || '',
                        relationship: details.nomineeRelationship?.id || '',
                        uploadAadhaar: details.aadhaarFileName ? { name: details.aadhaarFileName } : null,
                        uploadPan: details.panCardFileName ? { name: details.panCardFileName } : null,
                        uploadUan: details.uanCardFileName ? { name: details.uanCardFileName } : null,
                        uploadEsi: details.esiCardFileName ? { name: details.esiCardFileName } : null,
                        passportSizePhoto: details.employeepassportSizeFileName
                            ? { name: details.employeepassportSizeFileName }
                            : null,
                        fatherGivenName: appData.fatherGivenName || '',
                        fatherSurname: appData.fatherSurname || '',
                        uploadFatherIdProof: details.fatherIdProof ? { name: details.fatherIdProof } : null,
                        motherGivenName: appData.motherGivenName || '',
                        motherSurname: appData.motherSurname || '',
                        uploadMotherIdProof: details.motherIdProof ? { name: details.motherIdProof } : null,
                        spouseGivenName: appData.spouseName || '',
                        spouseSurname: appData.spouseSurname || '',
                        uploadSpouseIdProof: details.spouseIdProof ? { name: details.spouseIdProof } : null,
                        uploadPhysicalHandicappedCertificate: details.pwdCertificate ? { name: details.pwdCertificate } : null,
                        creamyLayerFile:details.creamyLayerFile?{name:details.creamyLayerFile}:null,
                        isNomineeStayingWithYou: details.isNomineeStayingWithYou || false,

                        // All verified/comment fields are correctly mapped here when details exist
                        aadhaarVerified: details.aadhaarVerified || null,
                        aadhaarComment: details.aadhaarComment || null,
                        panVerified: details.panVerified || null,
                        panComment: details.panComment || null,
                        uanVerified: details.uanVerified || null,
                        uanComment: details.uanComment || null,
                        esiVerified: details.esiVerified || null,
                        esiComment: details.esiComment || null,
                        photoVerified: details.photoVerified || null,
                        photoComment: details.photoComment || null,
                        emailSent: details.emailSent || false,
                        verifiedBy: details.verifiedBy || null,
                        updatedBy: details.updatedBy || '',
                        createdDate: details.createdDate || null,
                        updatedDate: details.updatedDate || null,
                    });
                    setHasUan(details.hasUanNumber ? 'yes' : 'no');
                    setHasEsi(details.hasEsiNumber ? 'yes' : 'no');
                    setNomineeStaying(details.isNomineeStayingWithYou ? 'yes' : 'no');
                } else {
                    // Initialize state with default values if employeeIDDetails is missing
                    setIdDetails({
                        id: null,
                        aadhaarNumber: '',
                        nameAsAadhar: '',
                        panCardNumber: '',
                        nameAsPerPanCard: '',
                        uanNumber: '',
                        uanMemberId: '',
                        esiNumber: '',
                        nomineeName: '',
                        relationship: '',
                        uploadAadhaar: null,
                        uploadPan: null,
                        uploadUan: null,
                        uploadEsi: null,
                        passportSizePhoto: null,
                        fatherGivenName: appData.fatherGivenName || '',
                        fatherSurname: appData.fatherSurname || '',
                        uploadFatherIdProof: null,
                        motherGivenName: appData.motherGivenName || '',
                        motherSurname: appData.motherSurname || '',
                        uploadMotherIdProof: null,
                        spouseGivenName: appData.spouseName || '',
                        spouseSurname: appData.spouseSurname || '',
                        uploadSpouseIdProof: null,
                        uploadPhysicalHandicappedCertificate: null,
                        isNomineeStayingWithYou: false,
                        creamyLayerFile:null,
                        // Set all verification fields to null/default
                        aadhaarVerified: null,
                        aadhaarComment: null,
                        panVerified: null,
                        panComment: null,
                        uanVerified: null,
                        uanComment: null,
                        esiVerified: null,
                        esiComment: null,
                        photoVerified: null,
                        photoComment: null,
                        emailSent: false,
                        verifiedBy: null,
                        updatedBy: '',
                        createdDate: null,
                        updatedDate: null,
                    });
                    setHasUan('');
                    setHasEsi('');
                    setNomineeStaying('');
                }

                // This section is fine and uses appData (which is defined in the try block)
                setPersonalInfo({
                    givenName: appData.givenName || appData.employee?.firstName || '',
                    surname: appData.surname || appData.employee?.lastName || '',
                    jobPosition: appData.employee?.jobPosition || '',
                });
                setCompleted(appData.completed === true);
                console.log('Fetched application data:', appData);
            } catch (error) {
                console.error('Error fetching application data:', error);
            }
        };
        if (!effectRan.current) {
            fetchApplicationDetails();
            setIsDirty(false);
        }
        return () => {
            effectRan.current = true;
        }

    }, [employeeUniqueId]);

    // Handle input changes
    const handleInputChange = (eOrOption, fieldName) => {
        let name, value;
        if (eOrOption && eOrOption.target) {
            ({ name, value } = eOrOption.target);
        } else {
            name = fieldName;
            value = eOrOption ? eOrOption.value : '';
        }
        if (['aadhaarNumber', 'panCardNumber', 'uanNumber', 'uanMemberId', 'esiNumber'].includes(name) && submitError) {
            setSubmitError('');
        }
        setIdDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
        validateField(name, value);
        setIsDirty(true);
    };

    // Handle file changes with size validation
    const handleFileChange = (e, fieldName) => {
        const file = e.target.files[0];
        if (file) {
            // Validate file size only for passportSizePhoto (1 MB = 1,048,576 bytes)
            if (fieldName === 'passportSizePhoto' && file.size > 1048576) {
                setFileErrors((prev) => ({
                    ...prev,
                    [fieldName]: 'Passport photo size must be less than 1 MB',
                }));
                return;
            }
            // Validate file type for passportSizePhoto
            if (fieldName === 'passportSizePhoto' && !['image/jpeg', 'image/png'].includes(file.type)) {
                setFileErrors((prev) => ({
                    ...prev,
                    [fieldName]: 'Only JPG and PNG files are allowed for passport photo',
                }));
                return;
            }
            setFileErrors((prev) => ({
                ...prev,
                [fieldName]: '',
            }));
            setIdDetails((prev) => ({
                ...prev,
                [fieldName]: { name: file.name, size: file.size, type: file.type },
            }));
            if (!window._uploadedFiles) window._uploadedFiles = {};
            window._uploadedFiles[fieldName] = file;
            setIsDirty(true);
        }
    };

    // Validate individual field
    const validateField = (name, value) => {
        const newErrors = { ...errors };
        switch (name) {
            case 'aadhaarNumber':
                if (!value || value.length !== 12 || !/^\d{12}$/.test(value)) {
                    newErrors.aadhaarNumber = 'Aadhaar Number must be 12 digits';
                } else {
                    delete newErrors.aadhaarNumber;
                }
                break;
            case 'nameAsAadhar':
                if (!value.trim()) {
                    newErrors.nameAsAadhar = 'Name as per Aadhaar is required';
                } else {
                    delete newErrors.nameAsAadhar;
                }
                break;
            case 'panCardNumber':
                if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
                    newErrors.panCardNumber = 'PAN must be 10 characters (e.g., ABCDE1234F)';
                } else {
                    delete newErrors.panCardNumber;
                }
                break;
            case 'nameAsPerPanCard':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.nameAsPerPanCard = 'Name as per PAN Card must contain only letters';
                } else {
                    delete newErrors.nameAsPerPanCard;
                }
                break;
            case 'uanNumber':
                if (hasUan === 'yes' && (!value || value.length !== 12 || !/^\d{12}$/.test(value))) {
                    newErrors.uanNumber = 'UAN Number must be 12 digits';
                } else {
                    delete newErrors.uanNumber;
                }
                break;
            case 'uanMemberId':
                if (hasUan === 'yes' && (!value || !/^[A-Z]{5}[0-9]{17}$/.test(value))) {
                    newErrors.uanMemberId = 'UAN Member ID must be 5 letters followed by 17 digits';
                } else {
                    delete newErrors.uanMemberId;
                }
                break;
            case 'esiNumber':
                if (hasEsi === 'yes' && (!value || value.length !== 10 || !/^\d{10}$/.test(value))) {
                    newErrors.esiNumber = 'ESI Number must be 10 digits';
                } else {
                    delete newErrors.esiNumber;
                }
                break;
            case 'fatherGivenName':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.fatherGivenName = 'Father\'s Given Name must contain only letters';
                } else {
                    delete newErrors.fatherGivenName;
                }
                break;
            case 'fatherSurname':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.fatherSurname = 'Father\'s Surname must contain only letters';
                } else {
                    delete newErrors.fatherSurname;
                }
                break;
            case 'motherGivenName':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.motherGivenName = 'Mother\'s Given Name must contain only letters';
                } else {
                    delete newErrors.motherGivenName;
                }
                break;
            case 'motherSurname':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.motherSurname = 'Mother\'s Surname must contain only letters';
                } else {
                    delete newErrors.motherSurname;
                }
                break;
            case 'spouseGivenName':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.spouseGivenName = 'Spouse\'s Given Name must contain only letters';
                } else {
                    delete newErrors.spouseGivenName;
                }
                break;
            case 'spouseSurname':
                if (value && !/^[a-zA-Z\s]*$/.test(value)) {
                    newErrors.spouseSurname = 'Spouse\'s Surname must contain only letters';
                } else {
                    delete newErrors.spouseSurname;
                }
                break;
            default:
                break;
        }
        setErrors(newErrors);
    };

    // Validate entire form
    const validateForm = () => {
        const newErrors = {};
        if (!idDetails.aadhaarNumber || idDetails.aadhaarNumber.length !== 12 || !/^\d{12}$/.test(idDetails.aadhaarNumber)) {
            newErrors.aadhaarNumber = 'Aadhaar Number must be 12 digits';
        }
        if (!idDetails.nameAsAadhar.trim()) {
            newErrors.nameAsAadhar = 'Name as per Aadhaar is required';
        }
        if (!hasUan) {
            newErrors.hasUan = 'Please select if you have a UAN number';
        } else if (hasUan === 'yes') {
            if (!idDetails.uanNumber || idDetails.uanNumber.length !== 12 || !/^\d{12}$/.test(idDetails.uanNumber)) {
                newErrors.uanNumber = 'UAN Number must be 12 digits';
            }
            // if (!idDetails.uanMemberId || !/^[A-Z]{5}[0-9]{17}$/.test(idDetails.uanMemberId)) {
            //     newErrors.uanMemberId = 'UAN Member ID must be 5 letters followed by 17 digits';
            // }
        }
        if (!hasEsi) {
            newErrors.hasEsi = 'Please select if you have an ESI number';
        } else if (hasEsi === 'yes') {
            if (!idDetails.esiNumber || idDetails.esiNumber.length !== 10 || !/^\d{10}$/.test(idDetails.esiNumber)) {
                newErrors.esiNumber = 'ESI Number must be 10 digits';
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Check if form is valid
    const isFormValid = () => {
        const isPanValid = !idDetails.panCardNumber || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idDetails.panCardNumber);
        const isPanNameValid = !idDetails.nameAsPerPanCard || idDetails.nameAsPerPanCard.trim() !== '';
        const isUanValid = hasUan === 'no' || (/^\d{12}$/.test(idDetails.uanNumber));
        const isEsiValid = hasEsi === 'no' || /^\d{10}$/.test(idDetails.esiNumber);
        const isFileValid = Object.values(fileErrors).every((error) => error === '');
        return (
            idDetails.aadhaarNumber &&
            /^\d{12}$/.test(idDetails.aadhaarNumber) &&
            idDetails.nameAsAadhar.trim() !== '' &&
            isPanValid &&
            isPanNameValid &&
            hasUan !== '' &&
            isUanValid &&
            hasEsi !== '' &&
            isEsiValid &&
            isFileValid
        );
    };

    useEffect(() => {
        setIsButtonEnabled(isFormValid());
    }, [idDetails, hasUan, hasEsi, fileErrors]);

    // Capitalize words
    // const capitalizeFirstLetter = (input) => {
    //     if (!input) return '';
    //     let value = input.replace(/[^a-zA-Z\s]/g, '');
    //     return value
    //         .split(' ')
    //         .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''))
    //         .join(' ');
    // };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitError('');
        if (!employeeUniqueId) {
            setSubmitError('Draft ID is missing. Please ensure you are accessing the form correctly.');
            return;
        }
        if (!validateForm()) {
            setSubmitError('Please correct the errors in the form.');
            return;
        }
        try {
            const formData = new FormData();
            const fullName = localStorage.getItem('full_name');
            const role = localStorage.getItem('role');
            const employeeId = localStorage.getItem('employeeId');
            const payload = {
                idDetails: {
                    ...(idDetails.id ? { id: idDetails.id } : {}),
                    aadhaarNumber: idDetails.aadhaarNumber || null,
                    nameAsPerAadhaar: idDetails.nameAsAadhar || null,
                    panCardNumber: idDetails.panCardNumber || null,
                    nameAsPerPanCard: idDetails.nameAsPerPanCard || null,
                    hasUanNumber: hasUan === 'yes',
                    uanNumber: hasUan === 'yes' ? idDetails.uanNumber : null,
                    uanMemberId: hasUan === 'yes' ? idDetails.uanMemberId : null,
                    hasEsiNumber: hasEsi === 'yes',
                    esiNumber: hasEsi === 'yes' ? idDetails.esiNumber : null,
                    nomineeName: idDetails.nomineeName || null,
                    isNomineeStayingWithYou: nomineeStaying === 'yes',
                    nomineeRelationship: idDetails.relationship ? { id: Number(idDetails.relationship) } : null,
                    fatherGivenName: idDetails.fatherGivenName || null,
                    fatherSurname: idDetails.fatherSurname || null,
                    motherGivenName: idDetails.motherGivenName || null,
                    motherSurname: idDetails.motherSurname || null,
                    spouseGivenName: idDetails.spouseGivenName || null,
                    spouseSurname: idDetails.spouseSurname || null,
                    // fatherIdProof: idDetails.uploadFatherIdProof ? idDetails.uploadFatherIdProof.name : null,
                    // motherIdProof: idDetails.uploadMotherIdProof ? idDetails.uploadMotherIdProof.name : null,
                    // spouseIdProof: idDetails.uploadSpouseIdProof ? idDetails.uploadSpouseIdProof.name : null,
                    // pwdCertificate: idDetails.uploadPhysicalHandicappedCertificate ? idDetails.uploadPhysicalHandicappedCertificate.name : null,
                    // aadhaarVerified: idDetails.aadhaarVerified || null,
                    // aadhaarComment: idDetails.aadhaarComment || null,
                    // panVerified: idDetails.panVerified || null,
                    // panComment: idDetails.panComment || null,
                    // uanVerified: idDetails.uanVerified || null,
                    // uanComment: idDetails.uanComment || null,
                    // esiVerified: idDetails.esiVerified || null,
                    // esiComment: idDetails.esiComment || null,
                    // photoVerified: idDetails.photoVerified || null,
                    // photoComment: idDetails.photoComment || null,
                    // emailSent: idDetails.emailSent || false,
                    // verifiedBy: idDetails.verifiedBy || null,
                    // updatedBy: idDetails.updatedBy || null,
                    // createdDate: idDetails.createdDate || null,
                    // updatedDate: idDetails.updatedDate || null,
                },
            };
            if (employeeId && role) {
                // payload.auditLog = {
                //     name: fullName,
                //     role: role,
                //     employeeId: employeeId,
                // };
                payload.auditLog = getAuditLog();
            }
            formData.append('idDetails', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
            if (idDetails.uploadAadhaar && window._uploadedFiles?.uploadAadhaar) {
                formData.append('aadhaarFile', window._uploadedFiles.uploadAadhaar);
            }
            if (idDetails.uploadPan && window._uploadedFiles?.uploadPan) {
                formData.append('panFile', window._uploadedFiles.uploadPan);
            }
            if (idDetails.uploadUan && window._uploadedFiles?.uploadUan) {
                formData.append('uanCardFile', window._uploadedFiles.uploadUan);
            }
            if (idDetails.uploadEsi && window._uploadedFiles?.uploadEsi) {
                formData.append('esiCardFile', window._uploadedFiles.uploadEsi);
            }
            if (idDetails.passportSizePhoto && window._uploadedFiles?.passportSizePhoto) {
                formData.append('passportSizePhoto', window._uploadedFiles.passportSizePhoto);
            }
            if (idDetails.uploadFatherIdProof && window._uploadedFiles?.uploadFatherIdProof) {
                formData.append('fatherIdProofFile', window._uploadedFiles.uploadFatherIdProof);
            }
            if (idDetails.uploadMotherIdProof && window._uploadedFiles?.uploadMotherIdProof) {
                formData.append('motherIdProofFile', window._uploadedFiles.uploadMotherIdProof);
            }
            if (idDetails.uploadSpouseIdProof && window._uploadedFiles?.uploadSpouseIdProof) {
                formData.append('spouseIdProofFile', window._uploadedFiles.uploadSpouseIdProof);
            }
            if (idDetails.uploadPhysicalHandicappedCertificate && window._uploadedFiles?.uploadPhysicalHandicappedCertificate) {
                formData.append('pwdCertificateFile', window._uploadedFiles.uploadPhysicalHandicappedCertificate);
            }
              if (idDetails.creamyLayerFile && window._uploadedFiles?.creamyLayerFile) {
                formData.append('creamyLayerFile', window._uploadedFiles.creamyLayerFile);
            }
            const response = await submitIdDetails(employeeUniqueId, formData);
            console.log('ID details submission response:', response.data);
            localStorage.setItem('idDetails', JSON.stringify(idDetails));
            window._uploadedFiles = {};
            setFileErrors({
                uploadAadhaar: '',
                uploadPan: '',
                uploadUan: '',
                uploadEsi: '',
                passportSizePhoto: '',
                uploadFatherIdProof: '',
                uploadMotherIdProof: '',
                uploadSpouseIdProof: '',
                uploadPhysicalHandicappedCertificate: '',
                creamyLayerFile:'',
            });
            onNext();
        } catch (error) {
            console.error('Submission error:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            let errorMessage = 'Failed to submit ID details. Please try again.';
            if (error.response) {
                if (error.response.status === 400) {
                    errorMessage = error.response.data.message || error.response.data.error || 'Invalid data provided.';
                } else if (error.response.status === 401) {
                    errorMessage = 'Unauthorized. Please log in and try again.';
                } else if (error.response.status === 404) {
                    errorMessage = 'Draft ID not found. Please verify.';
                } else if (error.response.status >= 500) {
                    errorMessage = 'Server error. Please try again later.';
                }
            } else if (error.request) {
                errorMessage = 'No response from server. Please check your network.';
            }
            setSubmitError(errorMessage);
        }
    };

    // Handle previous click
    const handlePreviousClick = () => {
        const isFormEmpty =
            !idDetails.aadhaarNumber &&
            !idDetails.nameAsAadhar &&
            !idDetails.panCardNumber &&
            !idDetails.nameAsPerPanCard &&
            !idDetails.uanNumber &&
            !idDetails.uanMemberId &&
            !idDetails.esiNumber &&
            !idDetails.nomineeName &&
            !idDetails.relationship &&
            !idDetails.uploadAadhaar &&
            !idDetails.uploadPan &&
            !idDetails.uploadUan &&
            !idDetails.uploadEsi &&
            !idDetails.passportSizePhoto &&
            !idDetails.fatherGivenName &&
            !idDetails.fatherSurname &&
            !idDetails.uploadFatherIdProof &&
            !idDetails.motherGivenName &&
            !idDetails.motherSurname &&
            !idDetails.uploadMotherIdProof &&
            !idDetails.spouseGivenName &&
            !idDetails.spouseSurname &&
            !idDetails.uploadSpouseIdProof &&
            !idDetails.uploadPhysicalHandicappedCertificate&&
            !idDetails.creamyLayerFile;
        if (isFormEmpty || !isDirty) {
            onPrevious();
        } else {
            setShowConfirmModal(true);
        }
    };

    const handleConfirmYes = () => {
        setIdDetails({
            id: null,
            aadhaarNumber: '',
            nameAsAadhar: '',
            panCardNumber: '',
            nameAsPerPanCard: '',
            uanNumber: '',
            uanMemberId: '',
            esiNumber: '',
            nomineeName: '',
            relationship: '',
            uploadAadhaar: null,
            uploadPan: null,
            uploadUan: null,
            uploadEsi: null,
            passportSizePhoto: null,
            fatherGivenName: '',
            fatherSurname: '',
            uploadFatherIdProof: null,
            motherGivenName: '',
            motherSurname: '',
            uploadMotherIdProof: null,
            spouseGivenName: '',
            spouseSurname: '',
            uploadSpouseIdProof: null,
            uploadPhysicalHandicappedCertificate: null,
            isNomineeStayingWithYou: false,
            aadhaarVerified: null,
            aadhaarComment: null,
            panVerified: null,
            panComment: null,
            uanVerified: null,
            uanComment: null,
            esiVerified: null,
            esiComment: null,
            photoVerified: null,
            photoComment: null,
            emailSent: false,
            verifiedBy: null,
            updatedBy: '',
            createdDate: null,
            updatedDate: null,
            creamyLayerFile:null,
        });
        setFileErrors({
            uploadAadhaar: '',
            uploadPan: '',
            uploadUan: '',
            uploadEsi: '',
            passportSizePhoto: '',
            uploadFatherIdProof: '',
            uploadMotherIdProof: '',
            uploadSpouseIdProof: '',
            uploadPhysicalHandicappedCertificate: '',
            creamyLayerFile:'',
        });
        setShowConfirmModal(false);
        onPrevious();
    };

    const handleConfirmNo = () => {
        setShowConfirmModal(false);
    };

    // Extract file name for display
    // function getFileName(url) {
    //     if (!url) return '';
    //     const fileName = url.split('/').pop();
    //     const lastUnderscore = fileName.lastIndexOf('_');
    //     return lastUnderscore !== -1 ? fileName.substring(lastUnderscore + 1) : fileName;
    // }

    return (
        <div className="idDetails-container">
            <div className="idDetails-box">
                <form onSubmit={handleSubmit}>
                    <div className="IDDdetails-heading">
                        <span className="highlight-label">Temporary ID : </span>
                        {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} -{' '}
                        {personalInfo.jobPosition.designationName}
                    </div>
                    <h2 className="idddetails-heading">ID Details</h2>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="aadhaarNumber"
                                    value={idDetails.aadhaarNumber}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d{0,12}$/.test(value)) {
                                            handleInputChange(e);
                                        }
                                    }}
                                    placeholder=" "
                                    maxLength="12"
                                    pattern="^[0-9]{12}$"
                                    title="Please enter a valid 12-digit Aadhaar number."
                                    disabled
                                />
                                <label>
                                    <span className="required">*</span>Aadhaar Number
                                </label>
                                {errors.aadhaarNumber && <p className="error">{errors.aadhaarNumber}</p>}
                                {submitError && submitError.includes('Aadhaar') && (
                                    <p className="error-text">{submitError}</p>
                                )}
                            </div>
                        </div>
                        <div className="idDetails-container-part-2">
                            <div className="idDetails-floating-label-container-2">
                                <input
                                    type="text"
                                    name="nameAsAadhar"
                                    value={idDetails.nameAsAadhar}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (isAlphabet(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'nameAsAadhar', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled={isFieldDisabled}
                                />
                                <label>
                                    <span className="required">*</span>Name as per Aadhaar
                                </label>
                                {errors.nameAsAadhar && <p className="error">{errors.nameAsAadhar}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload Aadhaar Card</label>
                                {(() => {
                                    const isAppCompleted = isFieldDisabled;
                                    const isCertificateVerified = idDetails.aadhaarVerified === true;
                                    const disableFileInput = isAppCompleted && isCertificateVerified;
                                    return (
                                        <input
                                            type="file"
                                            name="uploadAadhaar"
                                            onChange={(e) => handleFileChange(e, 'uploadAadhaar')}
                                            disabled={disableFileInput}
                                        />
                                    )
                                })()}

                            </div>
                            {idDetails.uploadAadhaar && (
                                <span>{getFileName(idDetails.uploadAadhaar.name)}</span>
                            )}
                            {fileErrors.uploadAadhaar && <p className="error">{fileErrors.uploadAadhaar}</p>}
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="panCardNumber"
                                    value={idDetails.panCardNumber}
                                    onChange={(e) => {
                                        let value = e.target.value.toUpperCase();
                                        value = value.replace(/[^A-Z0-9]/g, '');
                                        if (
                                            /^[A-Z]{0,5}$/.test(value) ||
                                            /^[A-Z]{5}[0-9]{0,4}$/.test(value) ||
                                            /^[A-Z]{5}[0-9]{4}[A-Z]{0,1}$/.test(value)
                                        ) {
                                            handleInputChange({ target: { name: 'panCardNumber', value } });
                                        }
                                    }}
                                    maxLength="10"
                                    placeholder=" "
                                    pattern="^[A-Z]{5}[0-9]{4}[A-Z]{1}$"
                                    title="PAN must be 10 characters: 5 letters, 4 digits, 1 letter (e.g. ABCDE1234F)"
                                    disabled={isFieldDisabled}
                                />
                                <label>PAN Card Number</label>
                                {errors.panCardNumber && <p className="error">{errors.panCardNumber}</p>}
                                {submitError && submitError.includes('PAN') && <p className="error">{submitError}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part-2">
                            <div className="idDetails-floating-label-container-2">
                                <input
                                    type="text"
                                    name="nameAsPerPanCard"
                                    value={idDetails.nameAsPerPanCard}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (isAlphabet(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'nameAsPerPanCard', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled={isFieldDisabled}
                                />
                                <label>Name as per PAN Card</label>
                                {errors.nameAsPerPanCard && <p className="error">{errors.nameAsPerPanCard}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload PAN Card</label>
                                {(() => {
                                    const isAppCompleted = isFieldDisabled;
                                    const isCertificateVerified = idDetails.panVerified === true;
                                    const disableFileInput = isAppCompleted && isCertificateVerified;
                                    return (
                                        <input
                                            type="file"
                                            name="uploadPan"
                                            onChange={(e) => handleFileChange(e, 'uploadPan')}
                                            disabled={disableFileInput}
                                        />
                                    )
                                })()}

                            </div>
                            {idDetails.uploadPan && <span>{getFileName(idDetails.uploadPan.name)}</span>}
                            {fileErrors.uploadPan && <p className="error">{fileErrors.uploadPan}</p>}
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1-left">
                            <label className="label-text-color">
                                <span className="required">*</span>Do you have a UAN Number?&nbsp;&nbsp;&nbsp;
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="hasUan"
                                    value="yes"
                                    checked={hasUan === 'yes'}
                                    onChange={(e) => {
                                        setHasUan(e.target.value);
                                        if (submitError.includes('UAN') || submitError.includes('Member'))
                                            setSubmitError('');
                                    }}
                                // disabled={isFieldDisabled}
                                />{' '}
                                Yes
                            </label>
                            <label style={{ marginLeft: '1em' }}>
                                <input
                                    type="radio"
                                    name="hasUan"
                                    value="no"
                                    checked={hasUan === 'no'}
                                    onChange={(e) => {
                                        setHasUan(e.target.value);
                                        if (submitError.includes('UAN') || submitError.includes('Member'))
                                            setSubmitError('');
                                    }}
                                // disabled={isFieldDisabled}
                                />{' '}
                                No
                            </label>
                            {errors.hasUan && <p className="error">{errors.hasUan}</p>}
                        </div>
                        <div className="idDetails-container-part-1"></div>
                        <div className="idDetails-container-part-1"></div>
                    </div>
                    <div className="idDetails-maincontainer">
                        {hasUan === 'yes' && (
                            <>
                                <div className="idDetails-container-part-1">
                                    <div className="idDetails-floating-label-container-1">
                                        <input
                                            type="text"
                                            name="uanNumber"
                                            value={idDetails.uanNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d{0,12}$/.test(value)) {
                                                    handleInputChange(e);
                                                }
                                            }}
                                            placeholder=" "
                                            maxLength="12"
                                            pattern="^[0-9]{12}$"
                                            title="Please enter a valid 12-digit UAN number."
                                         disabled={isLocked}
                                        />
                                        <label>
                                            <span className="required">*</span>UAN Number
                                        </label>
                                        {errors.uanNumber && <p className="error">{errors.uanNumber}</p>}
                                        {submitError && submitError.includes('UAN') && !submitError.includes('Member') && (
                                            <p className="error-text">{submitError}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="idDetails-container-part-2">
                                    <div className="idDetails-floating-label-container-2">
                                        <input
                                            type="text"
                                            name="uanMemberId"
                                            value={idDetails.uanMemberId}
                                            onChange={(e) => {
                                                let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                                if (
                                                    /^[A-Z]{0,5}$/.test(value) ||
                                                    /^[A-Z]{5}[0-9]{0,17}$/.test(value)
                                                ) {
                                                    handleInputChange({ target: { name: 'uanMemberId', value } });
                                                }
                                            }}
                                            disabled={isFieldDisabled}
                                            maxLength="22"
                                            placeholder=" "
                                            pattern="^[A-Z]{5}[0-9]{17}$"
                                            title="UAN Member ID must be 5 letters followed by 17 digits"
                                        />
                                        <label>
                                            Member ID
                                        </label>
                                        {errors.uanMemberId && <p className="error">{errors.uanMemberId}</p>}
                                        {submitError && submitError.includes('Member') && (
                                            <p className="error-text">{submitError}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="idDetails-container-part">
                                    <div className="idDetails-input-label">
                                        <label>Upload UAN Card</label>
                                        {(() => {
                                            const isAppCompleted = isFieldDisabled;
                                            const isCertificateVerified = idDetails.uanVerified === true;
                                            const disableFileInput = isAppCompleted && isCertificateVerified;
                                            return (
                                                <input
                                                    type="file"
                                                    name="uploadUan"
                                                    onChange={(e) => handleFileChange(e, 'uploadUan')}
                                                    disabled={disableFileInput}
                                                />
                                            )
                                        })()}


                                    </div>
                                    {idDetails.uploadUan && <span>{getFileName(idDetails.uploadUan.name)}</span>}
                                    {fileErrors.uploadUan && <p className="error">{fileErrors.uploadUan}</p>}
                                </div>
                            </>
                        )}
                    </div>
              {/* Calculate disable state once */}
{(() => {
    // If completed AND verified, fields are locked.
    // If completed but NOT verified (false or null), fields are enabled for correction.
    const disableEsiFields = isFieldDisabled && idDetails.esiVerified === true;

    return (
        <div className="idDetails-maincontainer">
            <div className="idDetails-container-part-1-left">
                <label className="label-text-color">
                    <span className="required">*</span>Do you have an ESIC Number?&nbsp;&nbsp;&nbsp;
                </label>
                <label>
                    <input
                        type="radio"
                        name="hasEsi"
                        value="yes"
                        checked={hasEsi === 'yes'}
                        onChange={(e) => {
                            setHasEsi(e.target.value);
                            if (submitError.includes('ESI')) setSubmitError('');
                        }}
                        // Radio buttons disabled only if globally completed (Standard lock)
                        disabled={isFieldDisabled} 
                    />{' '}
                    Yes
                </label>
                <label style={{ marginLeft: '1em' }}>
                    <input
                        type="radio"
                        name="hasEsi"
                        value="no"
                        checked={hasEsi === 'no'}
                        onChange={(e) => {
                            setHasEsi(e.target.value);
                            if (submitError.includes('ESI')) setSubmitError('');
                        }}
                        // Radio buttons disabled only if globally completed (Standard lock)
                        disabled={isFieldDisabled} 
                    />{' '}
                    No
                </label>
                {errors.hasEsi && <p className="error">{errors.hasEsi}</p>}
            </div>
            {hasEsi === 'yes' && (
                <>
                    <div className="idDetails-container-part-2">
                        <div className="idDetails-floating-label-container-2">
                            <input
                                type="text"
                                name="esiNumber"
                                value={idDetails.esiNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) {
                                        handleInputChange(e);
                                    }
                                }}
                                placeholder=" "
                                maxLength="10"
                                pattern="^[0-9]{10}$"
                                title="Please enter a valid 10-digit ESI number."
                                // ✅ Conditional Disable for ESI Number input
                                disabled={disableEsiFields} 
                            />
                            <label>
                                <span className="required">*</span>ESIC-IP Number
                            </label>
                            {errors.esiNumber && <p className="error">{errors.esiNumber}</p>}
                            {submitError && submitError.includes('ESI') && (
                                <p className="error-text">{submitError}</p>
                            )}
                        </div>
                    </div>
                    <div className="idDetails-container-part">
                        <div className="idDetails-input-label">
                            <label>Upload ESIC Card</label>
                            <input
                                type="file"
                                name="uploadEsi"
                                onChange={(e) => handleFileChange(e, 'uploadEsi')}
                                // ✅ Conditional Disable for ESI File upload
                                disabled={disableEsiFields} 
                            />
                        </div>
                        {idDetails.uploadEsi && <span>{getFileName(idDetails.uploadEsi.name)}</span>}
                        {fileErrors.uploadEsi && <p className="error">{fileErrors.uploadEsi}</p>}
                    </div>
                </>
            )}
        </div>
    );
})()}
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="nomineeName"
                                    value={idDetails.nomineeName}
                                    onChange={(e) => {
                                        const formatted = capitalizeFirstLetter(e.target.value);
                                        handleInputChange({ target: { name: 'nomineeName', value: formatted } });
                                    }}
                                    placeholder=" "
                                    disabled={isFieldDisabled}
                                />
                                <label>Nominee Name</label>
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div
                                className={`idDetails-floating-label-container-2 ${idDetails.relationship || isFocused.relationship ? 'float-label' : ''
                                    }`}
                            >
                                <Select
                                    name="relationship"
                                    options={relationshipOptions}
                                    value={relationshipOptions.find((opt) => opt.value === idDetails.relationship) || null}
                                    onChange={(selectedOption) => handleInputChange(selectedOption, 'relationship')}
                                    onFocus={() => setIsFocused((prev) => ({ ...prev, relationship: true }))}
                                    onBlur={() => setIsFocused((prev) => ({ ...prev, relationship: false }))}
                                    placeholder=" "
                                    isClearable
                                    // styles={{
                                    //     menuPortal: (base) => ({
                                    //         ...base,
                                    //         zIndex: 9999,
                                    //         position: 'absolute',
                                    //         top: 'auto',
                                    //         bottom: '100%',
                                    //     }),
                                    //     menu: (base) => ({ ...base, marginTop: '5px', zIndex: 9999 }),
                                    //     control: (provided) => ({ ...provided, padding: '1px' }),
                                    //     valueContainer: (provided) => ({ ...provided, padding: '3px 6px' }),
                                    // }}
                                    isDisabled={isFieldDisabled}
                                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                                />
                                <label>Relationship with Nominee</label>
                                {errors.relationship && <p className="error">{errors.relationship}</p>}
                            </div>
                        </div>
                        <div className="nominee-alignment">
                            <label className="label-text-color"> Is Nominee Staying With You :</label> &nbsp;&nbsp;
                            <label>
                                <input
                                    type="radio"
                                    name="nomineeStaying"
                                    value="yes"
                                    checked={nomineeStaying === 'yes'}
                                    onChange={(e) => setNomineeStaying(e.target.value)}
                                    disabled={isFieldDisabled}
                                />{' '}
                                Yes
                            </label>
                            <label style={{ marginLeft: '1em' }}>
                                <input
                                    type="radio"
                                    name="nomineeStaying"
                                    value="no"
                                    checked={nomineeStaying === 'no'}
                                    onChange={(e) => setNomineeStaying(e.target.value)}
                                />{' '}
                                No &nbsp;&nbsp;
                            </label>
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="fatherGivenName"
                                    value={idDetails.fatherGivenName}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'fatherGivenName', value } });
                                        }
                                    }}
                                    disabled
                                    placeholder=" "

                                />
                                <label>Father's Given Name</label>
                                {errors.fatherGivenName && <p className="error">{errors.fatherGivenName}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part-2">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="fatherSurname"
                                    value={idDetails.fatherSurname}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'fatherSurname', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled

                                />
                                <label>Father's Surname Name</label>
                                {errors.fatherSurname && <p className="error">{errors.fatherSurname}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload Father's Id Proof</label>
                                <input
                                    type="file"
                                    name="uploadFatherIdProof"
                                    onChange={(e) => handleFileChange(e, 'uploadFatherIdProof')}
                                    disabled={isFieldDisabled}
                                />
                            </div>
                            {idDetails.uploadFatherIdProof && (
                                <span>{getFileName(idDetails.uploadFatherIdProof.name)}</span>
                            )}
                            {fileErrors.uploadFatherIdProof && <p className="error">{fileErrors.uploadFatherIdProof}</p>}
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="motherGivenName"
                                    value={idDetails.motherGivenName}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'motherGivenName', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled
                                />
                                <label>Mother's Given Name</label>
                                {errors.motherGivenName && <p className="error">{errors.motherGivenName}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part-2">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="motherSurname"
                                    value={idDetails.motherSurname}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'motherSurname', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled
                                />
                                <label>Mother's Surname Name</label>
                                {errors.motherSurname && <p className="error">{errors.motherSurname}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload Mother's Id Proof</label>
                                <input
                                    type="file"
                                    name="uploadMotherIdProof"
                                    onChange={(e) => handleFileChange(e, 'uploadMotherIdProof')}
                                    disabled={isFieldDisabled}
                                />
                            </div>
                            {idDetails.uploadMotherIdProof && (
                                <span>{getFileName(idDetails.uploadMotherIdProof.name)}</span>
                            )}
                            {fileErrors.uploadMotherIdProof && <p className="error">{fileErrors.uploadMotherIdProof}</p>}
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part-1">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="spouseGivenName"
                                    value={idDetails.spouseGivenName}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'spouseGivenName', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled
                                />
                                <label>Spouse's Given Name</label>
                                {errors.spouseGivenName && <p className="error">{errors.spouseGivenName}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part-2">
                            <div className="idDetails-floating-label-container-1">
                                <input
                                    type="text"
                                    name="spouseSurname"
                                    value={idDetails.spouseSurname}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            value = capitalizeFirstLetter(value);
                                            handleInputChange({ target: { name: 'spouseSurname', value } });
                                        }
                                    }}
                                    placeholder=" "
                                    disabled
                                />
                                <label>Spouse's Surname Name</label>
                                {errors.spouseSurname && <p className="error">{errors.spouseSurname}</p>}
                            </div>
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload Spouse's Id Proof</label>
                                <input
                                    type="file"
                                    name="uploadSpouseIdProof"
                                    onChange={(e) => handleFileChange(e, 'uploadSpouseIdProof')}
                                    disabled={isFieldDisabled}
                                />
                            </div>
                            {idDetails.uploadSpouseIdProof && (
                                <span>{getFileName(idDetails.uploadSpouseIdProof.name)}</span>
                            )}
                            {fileErrors.uploadSpouseIdProof && <p className="error">{fileErrors.uploadSpouseIdProof}</p>}
                        </div>
                    </div>
                    <div className="idDetails-maincontainer">
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <label>Upload Physical Handicapped Certificate</label>
                                <input
                                    type="file"
                                    name="uploadPhysicalHandicappedCertificate"
                                    onChange={(e) => handleFileChange(e, 'uploadPhysicalHandicappedCertificate')}
                                    disabled={isFieldDisabled}
                                />
                            </div>
                            {idDetails.uploadPhysicalHandicappedCertificate && (
                                <span>{getFileName(idDetails.uploadPhysicalHandicappedCertificate.name)}</span>
                            )}
                            {fileErrors.uploadPhysicalHandicappedCertificate && (
                                <p className="error">{fileErrors.uploadPhysicalHandicappedCertificate}</p>
                            )}
                        </div>
                        <div className="idDetails-container-part">
                            <div className="idDetails-input-label">
                                <div className="backround-for-image">
                                    <label>Upload Employee Digital Passport Size Photo With White Background</label>
                                    {(() => {
                                        const isAppCompleted = isFieldDisabled;
                                        const isCertificateVerified = idDetails.photoVerified === true;
                                        const disableFileInput = isAppCompleted && isCertificateVerified;
                                        return (
                                            <input
                                                type="file"
                                                name="passportSizePhoto"
                                                onChange={(e) => handleFileChange(e, 'passportSizePhoto')}
                                                accept=".jpg,.jpeg,.png"
                                                disabled={disableFileInput}
                                            />
                                        )
                                    })()}

                                </div>
                                {fileErrors.passportSizePhoto && <p className="error">{fileErrors.passportSizePhoto}</p>}
                                {idDetails.passportSizePhoto && (
                                    <span>{getFileName(idDetails.passportSizePhoto.name)}</span>
                                )}
                            </div>
                        </div>
                        <div className="idDetails-container-part"><div className="idDetails-input-label">
                                <label>Upload Non-Creamy Layer Certificate</label>
                                <input
                                    type="file"
                                    name="uploadNonCreamyLayerCertificate"
                                    onChange={(e) => handleFileChange(e, 'uploadNonCreamyLayerCertificate')}
                                    disabled={isFieldDisabled}
                                />
                            </div>
                            {idDetails.creamyLayerFile && (
                                <span>{getFileName(idDetails.creamyLayerFile.name)}</span>
                            )}
                            {fileErrors.creamyLayerFile && (
                                <p className="error">{fileErrors.creamyLayerFile}</p>
                            )}</div>
                    </div>
                    <div className="bankdetails-btn">
                        <button type="button" className="bankdetails-btn-previous" onClick={handlePreviousClick}>
                            Previous
                        </button>
                        <button type="submit" className="bankdetails-submit-btn" disabled={!isButtonEnabled}>
                            Save & Next
                        </button>
                    </div>
                </form>
            </div>
            {/* {showConfirmModal && (
                <div className="modal-overlay">
                    <div className="custom-modal">
                        <p>Do you want to clear the form?</p>
                        <div className="modal-buttons">
                            <button type="button" onClick={handleConfirmYes}>Yes</button>
                            <button type="button" onClick={handleConfirmNo}>No</button>
                        </div>
                    </div>
                </div>
            )} */}
            {showConfirmModal && (
                <ConfirmModal
                    message="Do you want to clear the form?"
                    onConfirm={handleConfirmYes}
                    onCancel={handleConfirmNo}
                />
            )}
        </div>
    );
};

export default IDDetails;